/* eslint-disable react/no-unescaped-entities */
import React, { useRef, useState } from 'react';

import Button from '../../../../components/Button';
import Alert from '../../../../components/Alert';
import Radio from '../../../../components/Inputs/Radio';
import { LinkCardCustom } from '../../../../components/Cards/LinkCard';

import LayoutDeMovimentacao from '../../../../assets/docs/LAYOUTMOVIMENTACAOGNDIVERSAOTS1.6.pdf';
import arquivoModelo from '../../../../assets/docs/MODELOLAYOUTENVIO.xlsx';

import stringNormalize from '../../../../utils/stringNormalize';
import { checkIsSupport, downloadFile } from '../../../../utils';

import { envioPorArquivo } from '../../../../services';

import { useGlobal } from '../../../../contexts/Global/context';

import * as S from './styles';

function EnviarArquivo({ setActiveTab }) {
    const attachInput = useRef(null);

    const { dataActiveContract, setShowSupportModal } = useGlobal();

    const [file, setFile] = useState(null);
    const [typeFile, setTypeFile] = useState({
        id: 'fileType',
        label: '',
        placeholder: '',
        type: 'radio',
        value: 'C',
        options: [
            {
                codigo: 'C',
                nome: 'Por contrato',
            },
            {
                codigo: 'G',
                nome: 'Por grupo de contrato',
            },
        ],
    });
    const [alerts, setAlerts] = useState([]);
    const [payload, setPayload] = useState([]);
    const [loadingSendButton, setLoadingSendButton] = useState(false);

    const acceptedFormats = ['csv', 'txt'];

    function handleFileChange({ event, id }) {
        if (!event.target.files) return;

        const dataFile = event.target.files[0];
        const { name: fileName, size: fileSize } = dataFile;

        setFile(dataFile);

        const fileExtention = fileName.substring(fileName.lastIndexOf('.') + 1);

        if (!acceptedFormats.includes(fileExtention.toLowerCase())) {
            event.target.value = '';
            setFile(null);
            return;
        }

        const dataDocument = {
            id,
            name: fileName,
            size: `${(fileSize / 1024).toFixed(2)}Kb`,
        };

        const reader = new FileReader();

        reader.onloadend = () => {
            const payloadDocument = {
                numeroContrato: dataActiveContract.numero,
                nomeArquivo: stringNormalize(dataDocument.name),
                arquivoBase64: reader.result.split(',')[1],
            };

            if (typeFile.value === 'G') {
                delete payloadDocument.numeroContrato;
                payloadDocument.codigoGrupoEmpresa = dataActiveContract.codGrupoEmpresa;
            }

            setPayload(payloadDocument);
        };

        reader.readAsDataURL(dataFile);
    }

    function handleFileTypeChange(event) {
        const { value } = event;

        setTypeFile({
            ...typeFile,
            value,
        });
    }

    async function handleSubmit() {
        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        let dataAlert = '';

        setLoadingSendButton(true);

        const response = (await envioPorArquivo(payload)) || {};

        if (response[0] && response[0].errorCode) {
            dataAlert = {
                type: 1,
                title: 'Erro no envio do arquivo',
                message: response[0].errorDescription,
            };
        }

        if (response.nomeArquivo === payload.nomeArquivo) {
            dataAlert = {
                type: 3,
                title: 'Seu arquivo foi enviado',
                message: [
                    [
                        'O processamento ocorrerá em breve. Acesse a opção ',
                        <S.LinkToConsultShipping
                            onClick={() => {
                                setActiveTab('2');
                            }}
                        >
                            "Consultar retornos de processamento"
                        </S.LinkToConsultShipping>,
                        ' para verificar o retorno do processamento do seu arquivo dentro de instantes.',
                    ],
                ],
            };

            attachInput.current.value = null;

            setFile(null);
        }

        setAlerts([dataAlert]);

        setLoadingSendButton(false);
    }

    return (
        <>
            {alerts.map((alert) => (
                <Alert key={alert.title} type={alert.type} title={alert.title} message={alert.message} />
            ))}

            <S.HeaderLabel>
                Nesta opção você pode fazer múltiplas movimentações cadastrais ao mesmo tempo.
            </S.HeaderLabel>
            <br />
            <S.DescriptionLabel>
                Acesse as{' '}
                <S.LinkLabel href={LayoutDeMovimentacao} download="Orientações de movimentação cadastral">
                    orientações de movimentação cadastral
                </S.LinkLabel>{' '}
                e veja as informações necessárias para fazer a movimentação cadastral do contrato.
            </S.DescriptionLabel>
            <S.SearchContainer>
                <div>
                    <S.ContainerRadio>
                        <Radio field={typeFile} onChange={handleFileTypeChange} />
                    </S.ContainerRadio>
                    <S.SendFileText>
                        <label htmlFor="file-input">Escolher arquivo (.csv ou .txt)</label>
                    </S.SendFileText>
                    <input
                        type="file"
                        id="file-input"
                        accept=".txt, .csv"
                        onChange={(event) => handleFileChange({ event, id: 1 })}
                        ref={attachInput}
                    />
                </div>
                <Button
                    id="continueStep"
                    type="primary"
                    loading={loadingSendButton}
                    onClick={() => handleSubmit(payload)}
                    disabled={!file}
                >
                    Enviar
                </Button>
            </S.SearchContainer>

            <S.LinkCardModel>
                <LinkCardCustom
                    title="Arquivo modelo"
                    desc="Baixe o arquivo modelo para envio."
                    icons={{ left: { name: 'description' }, right: { name: 'file_download', size: 25 } }}
                    altImg="Adicionar documento"
                    onClick={() => downloadFile('Arquivo Modelo', arquivoModelo)}
                />
            </S.LinkCardModel>
        </>
    );
}

export default EnviarArquivo;
